(function () {
    'use strict';

    a3_cabin_reports.directive('syllabus', syllabus);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name certificates
    * @restrict E
    * @description
    *   Implementation of syllabus
    * @example
    *   Usage:
    *   <syllabus></syllabus>
    * @ngInject
    */
    function syllabus(TrainingSessionFactory, FlightSessionFactory, $timeout) {
        function link(scope, element, attrs) {

            var isGround = false;
            var courseId = scope.dutyCourse.Id;

            if (scope.groundDuty) {
                isGround = true;
                var date = scope.groundDuty.DutyDateS;
                var dutyId = scope.groundDuty.Id;
            }
            else {
                var date = scope.crewRouteDuty.date;
                var dutyNo = scope.crewRouteDuty.DutyNo;
                var dutyDay = scope.crewRouteDuty.DutyDay;
            }

            scope.updateTraineesSyllabus = updateTraineesSyllabus;
            scope.selectTry = selectTry;
            scope.updateTry = updateTry;
            scope.oneAtATime = true;
            scope.addTry = addTry;
            scope.removeTry = removeTry;
            scope.setPanelStyle = setPanelStyle;
            scope.selectTryFromHeader = selectTryFromHeader;
            scope.gradeFromHeader = gradeFromHeader;

            scope.nonGradableSyllabus = scope.traineeSyllabi[0].Items.every(item => !item.IsGradable);
            scope.personalizedRemarks = false;
            scope.showPersonalizedRemarks = false;
            scope.personalizedRemarksChanged = personalizedRemarksChanged;
            scope.addTraineeRemarksRow = addTraineeRemarksRow;
            scope.traineesPersonalizedRemarks = [];
            scope.updatePersonalizeRemarks = updatePersonalizeRemarks;
            scope.deleteTraineeRemarks = deleteTraineeRemarks;
            scope.isAddRemarksButtonDisabled = isAddRemarksButtonDisabled;
            scope.traineeValueChanged = traineeValueChanged;
            scope.hasSelectedTrainee = false;

            scope.traineeSyllabi.forEach(function (traineeSyllabus) {
                traineeSyllabus.Items.forEach(function (syllabusItem) {
                    syllabusItem.usePersonalizedRemarks = false;
                    syllabusItem.traineesPersonalizedRemarks = [];
                    syllabusItem.Tries.forEach(function (attempt) {
                        //Check if default grade exists & set status
                        if (syllabusItem.IsGradable && !attempt.isReadOnly) {
                            itemAutoSelection(syllabusItem, attempt);               //select item depending on grade existence
                        }
                    });
                    setPanelStyle(syllabusItem);                                //ui depending on validation & status
                    updateTraineesSyllabus(syllabusItem, traineeSyllabus);     //copy values to all trainee syllabi 
                });
            });

            //Multiple syllabi - Get session to store competence grading
            if (scope.traineeSyllabi.length > 1) {
                scope.traineeSyllabi.forEach(function (traineeSyllabus) {
                    var crewId = traineeSyllabus.TraineeIds[0];
                    var trainee = scope.trainees.find(x => x.CrewId == crewId);
                    traineeSyllabus.TraineeName = trainee.Name;
                    traineeSyllabus.TraineeAimsId = trainee.AimsId;
                });
            }


            function gradeFromHeader(syllabus, syllabusItem) {
                var firstPendingTry = syllabusItem.Tries.filter(x => !x.isReadOnly)[0];
                updateTry(syllabus, syllabusItem, firstPendingTry);
                setPanelStyle(syllabusItem);
                updateTraineesSyllabus(syllabusItem, syllabus);

                triggerSyllabusClick();
            }

            function selectTryFromHeader(syllabus, syllabusItem) {
                var firstPendingTry = syllabusItem.Tries.filter(x => !x.isReadOnly)[0];
                selectTry(syllabus, syllabusItem, firstPendingTry);

                if (isGround) {
                    TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) { console.log(e) })
                }
                else {
                    FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) { console.log(e) })
                }

                triggerSyllabusClick();
            }

            function triggerSyllabusClick() {
                //preventDefault() and stopPropagation() prevents setReleaseStatus() to be triggered
                $timeout(function () {
                    var el = document.getElementById('syllabus');
                    angular.element(el).triggerHandler('click');
                }, 0);
            }

            function selectTry(syllabus, syllabusItem, attempt) {
                attempt.Selected = !attempt.Selected;
                syllabusItem.Selected = syllabusItem.Tries.filter(t => !t.isReadOnly).some(t => t.Selected);

                setPanelStyle(syllabusItem);
                updateTraineesSyllabus(syllabusItem, syllabus);
            }

            function updateTry(syllabus, syllabusItem, attempt) {
                if (syllabusItem.IsGradable) {
                    itemAutoSelection(syllabusItem, attempt);       //select item depending on grade existence
                }
                setPanelStyle(syllabusItem);                        //ui depending on validation & status
                updateTraineesSyllabus(syllabusItem, syllabus);     //copy values to all trainee syllabi 
                updateSession();                                    //save in IndexDb
            }

            function itemAutoSelection(syllabusItem, attempt) {
                var hasCompetencesGrading = attempt.TryGrading.Competences.some(x => x.Grading);
                if (attempt.TryGrading.Grade || hasCompetencesGrading) {
                    attempt.Selected = true;
                    syllabusItem.Selected = true;
                }
                else {
                    attempt.Selected = false;
                    syllabusItem.Selected = false;

                    //Check if any of the tries has grading - If not, deselect item
                    var pendingTries = syllabusItem.Tries.filter(x => !x.isReadOnly); //filter out history tries
                    for (var i = 0; i < pendingTries.length; i++) {
                        var itemTry = pendingTries[i];
                        var tryCompetenceGrading = itemTry.TryGrading.Competences.some(x => x.Grading);
                        if (itemTry.TryGrading.Grade || tryCompetenceGrading) {
                            syllabusItem.Selected = true;
                            break;
                        }
                    }
                }
            }

            function setPanelStyle(item) {
                var historyTriesCount = item.Tries.filter(x => x.isReadOnly).length;
                var newTriesCount = item.Tries.filter(x => !x.isReadOnly && x.Selected).length;
                item.TriesPerformedCount = historyTriesCount + newTriesCount;

                var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

                if (item.MandatoryCount == 0) {   //non-mandatory items are considered completed if performed at least once
                    completedItem = item.TriesPerformedCount >= 1;
                }

                var invalidItem = false;
                var nonCompetentItem = false;

                if (item.IsGradable && item.Selected) {
                    var gradingType = item.GradeType; //Numeric or Outcome or Competences
                    var traineeSelectedTries = item.Tries.filter(x => x.Selected);

                    traineeSelectedTries.forEach(function (selectedTry) {

                        var invalidGrading = gradingType != "Competences" && !selectedTry.TryGrading.Grade;
                        var invalidCompetences = gradingType == "Competences" && !selectedTry.TryGrading.isCompetenceValid;

                        if (invalidGrading || invalidCompetences) {
                            invalidItem = true;
                        }
                    });

                    if (!invalidItem && traineeSelectedTries.some(t => t.TryGrading.Grade === "Fail")) {
                        nonCompetentItem = true;
                    }

                    if (!invalidItem && gradingType == "Outcome" && item.MandatoryCount > 0) {
                        // Get the grades from the tries
                        var tries = item.Tries.map(t => t.TryGrading.Grade);
                        var mandatoryTries = item.MandatoryCount;
                        var competentCount = 0;
                        var nonCompetentCount = 0;
                        var isCompetent = false;

                        for (var i = 0; i < tries.length; i++) {
                            if (tries[i] === 'Pass') {
                                competentCount++;
                                nonCompetentCount = 0; // reset non-competent count
                                if (competentCount >= mandatoryTries) {
                                    // item.PanelClass = 'panel-border-left-green';
                                    isCompetent = true;
                                }
                            } else {
                                if (tries[i] === 'Fail') {
                                    nonCompetentCount++;
                                    competentCount = 0;
                                    if (nonCompetentCount >= mandatoryTries) {
                                        // item.PanelClass = 'panel-border-left-pink';
                                        nonCompetentItem = true;
                                        break; // Exit if mandatory fails are reached
                                    }
                                }
                            }
                        }

                        if (nonCompetentItem) {
                            item.PanelClass = 'panel-border-left-pink';
                        } else if (isCompetent) {
                            item.PanelClass = 'panel-border-left-green';
                        } else {
                            item.PanelClass = 'panel-border-left-blue';
                        }
                        return;
                    }

                    // if (!invalidItem && gradingType != "Outcome" && traineeSelectedTries.some(t => t.TryGrading.Grade === "Fail")) {
                    //     nonCompetentItem = true;
                    // }

                }

                // if (completedItem && !nonCompetentItem) {
                //     item.PanelClass = 'panel-green panel-border-left-green ';
                // } else if ((completedItem && nonCompetentItem)) {
                //     item.PanelClass = 'panel-border-left-pink';
                // }
                // else {
                //     item.PanelClass = 'panel-border-left-blue ';
                // }

                // if (invalidItem) {
                //     item.PanelClass = 'panel-border-left-orange ';
                // }
                if (invalidItem) {
                    item.PanelClass = 'panel-border-left-orange';
                } else if (completedItem && nonCompetentItem) {
                    item.PanelClass = 'panel-border-left-pink';
                } else if (completedItem && !nonCompetentItem) {
                    item.PanelClass = 'panel-green panel-border-left-green';
                } else {
                    item.PanelClass = 'panel-border-left-blue';
                }
            }

            function updateTraineesSyllabus(item, syllabus) {
                var crewIds = syllabus.TraineeIds;

                scope.trainees.filter(x => crewIds.includes(x.CrewId)).forEach(function (trainee) {
                    var sessionItem = trainee.Session.Items.find(sessionItem => item.Id == sessionItem.Id);
                    sessionItem.RepeatRequired = item.RepeatRequired;
                    sessionItem.Selected = item.Selected;
                    sessionItem.PhaseId = item.PhaseId;
                    sessionItem.Tries = deepCopy(item.Tries);
                    sessionItem.SyllabusItemId = item.Id;
                    sessionItem.TriesPerformedCount = item.TriesPerformedCount;
                });

                updatePersonalizeRemarks(item);
            }

            function deepCopy(originalObject) {
                return JSON.parse(JSON.stringify(originalObject));
            }

            function addTry(item, syllabus) {
                var competences = deepCopy(item.Competences);

                var newTry = {
                    Comments: null,
                    ActionNo: item.Tries.length + 1,
                    Selected: true,
                    TryGrading: { Grade: null, Competences: competences, GradeType: item.GradeType },
                };

                item.Selected = true;
                item.Tries.push(newTry);
                setPanelStyle(item);
                updateTraineesSyllabus(item, syllabus)
            }

            function removeTry(item, syllabus) {
                item.Tries.pop();

                if (!item.Tries.filter(x => !x.isReadOnly).length) {
                    item.Selected = false;
                }
                setPanelStyle(item);
                updateTraineesSyllabus(item, syllabus)
            }

            function updateSession() {
                if (isGround) {
                    TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) { console.log(e) })
                }
                else {
                    FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) { console.log(e) })
                }
            }

            // if syllabus is non-gradable instructor can add persomalized trainee remarks
            function addTraineeRemarksRow(syllabusItem, selectedTraineeId) {
                if (selectedTraineeId) {
                    var selectedTrainee = scope.trainees.find(trainee => trainee.CrewId == selectedTraineeId);
                    if (selectedTrainee) {
                        scope.selectedTraineeName = selectedTrainee.Name;
                        var newTraineeRemarks = {
                            id: selectedTrainee.CrewId,
                            name: selectedTrainee.Name,
                            remarks: "", // Add an empty remarks field for the new trainee
                            syllabusItemId: syllabusItem.Id
                        };

                        syllabusItem.selectedTrainee = newTraineeRemarks;
                        syllabusItem.traineesPersonalizedRemarks.push(newTraineeRemarks);
                    }
                }
            }

            scope.getAvailableTrainees = function (allTrainees, item) {
                if (!item || !item.traineesPersonalizedRemarks) {
                    return allTrainees;
                }

                // Get the IDs of already selected trainees
                var selectedTraineeIds = item.traineesPersonalizedRemarks.map(remark => remark.id);

                // Filter out the selected trainees
                return allTrainees.filter(trainee => !selectedTraineeIds.includes(trainee.CrewId));
            };

            function personalizedRemarksChanged(item) {
                if (item.usePersonalizedRemarks) {
                    item.showPersonalizedRemarks = true;
                    item.Tries.forEach(function (itemTry) {
                        itemTry.Comments = ""; // Clear comments when enabling personalized remarks
                    });
                } else {
                    item.showPersonalizedRemarks = false;
                    item.usePersonalizedRemarks = false;
                    scope.traineesPersonalizedRemarks = [];
                }
            }

            function updatePersonalizeRemarks(item) {
                if (item.traineesPersonalizedRemarks && item.traineesPersonalizedRemarks.length > 0) {
                    item.traineesPersonalizedRemarks.forEach(function (personalizedRemark) {
                        var trainee = scope.trainees.find(x => x.CrewId == personalizedRemark.id);
                        if (trainee) {
                            var sessionItem = trainee.Session.Items.find(item => item.SyllabusItemId == personalizedRemark.syllabusItemId);
                            if (sessionItem && sessionItem.Tries.length > 0) {
                                sessionItem.Tries[0].Comments = personalizedRemark.remarks;
                            }
                        }
                    });
                }
            }

            function deleteTraineeRemarks(traineeRemarks, item) {
                if (item) {
                    // Remove the trainee remarks from the array
                    var index = item.traineesPersonalizedRemarks.findIndex(remarks => remarks.id === traineeRemarks.id);
                    if (index !== -1) {
                        item.traineesPersonalizedRemarks.splice(index, 1);

                        // After deleting, sync the changes with the Session
                        updatePersonalizeRemarks(item);

                        // Enable the deleted trainee for the current item
                        item.selectedTrainee = null;
                    } else {
                        console.error("Trainee remarks not found for deletion.");
                    }
                } else {
                    console.error("Syllabus item not found for the trainee remarks.");
                }
            }

            function isAddRemarksButtonDisabled(item) {
                return !scope.getAvailableTrainees(scope.trainees, item).length;
            };

            function traineeValueChanged(selectedTrainee) {
                if (selectedTrainee) {
                    scope.hasSelectedTrainee = true;
                } else {
                    scope.hasSelectedTrainee = false;
                }
            }
        }
        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Training/syllabus.tpl.html',
            scope: false,
            link: link
        }
    }

})();
